import HttpClient from "../http/http_client";
export const PostContactRequest = async (contactDetails) => {
    try {
        const response = await HttpClient.post(`contact/`, contactDetails, {
            headers: { "Content-Type": "application/json" },
        })
        return {
            success : true,
            data : response.data,
        }
    } catch (error) {
        if (error.response) {
            const {status, data} = error.response;
            return {
                success : false,
                status : status,
                errors : data?.errors || null,
            };
        }
        
        return {
            success : false,
            status : null,
            errors : "Something went wrong. Please try again.",
        };
    }
};